import { render, staticRenderFns } from "./kpsrList.vue?vue&type=template&id=4acdf468"
import script from "./kpsrList.vue?vue&type=script&lang=js"
export * from "./kpsrList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4acdf468')) {
      api.createRecord('4acdf468', component.options)
    } else {
      api.reload('4acdf468', component.options)
    }
    module.hot.accept("./kpsrList.vue?vue&type=template&id=4acdf468", function () {
      api.rerender('4acdf468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/kpsrList.vue"
export default component.exports